export type Salary = FixedSalary | SalaryRange

interface BaseSalary {
  id?: number
  nodeName?: string
  nodeId?: string | number
  currency: string
  periodicity: string
  workplaces?: Workplace[]
}

export interface FixedSalary extends BaseSalary {
  gross: number
  min?: never
  max?: never
}

export interface SalaryRange extends BaseSalary {
  gross?: never
  min: number
  max: number
}

export interface Workplace {
  id: number
  name: string
}

export const SalaryPeriodicity = {
  yearly: 'yearly',
  monthly: 'monthly',
  weekly: 'weekly',
  daily: 'daily',
  hourly: 'hourly',
}
